import React, { useContext } from "react";
import { ThemeContext } from "../../../../constant/theme";

const Mo3tiButton = ({
  children,
  variant = "primary",
  icon: Icon,
  size = "md",
  onClick,
  disabled = false,
  title,
  ariaLabel,
  style = {},
  type = "button",
}) => {
  const { theme } = useContext(ThemeContext);

  const buttonStyles = {
    primary: {
      background: "#2e7cba",
      color: "white",
      border: "none",
    },
    secondary: {
      background:
        theme === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.05)",
      color: theme === "dark" ? "white" : "#1a1a1a",
      border:
        theme === "dark"
          ? "1px solid rgba(255,255,255,0.2)"
          : "1px solid rgba(0,0,0,0.1)",
    },
    ghost: {
      background: "transparent",
      color: theme === "dark" ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.6)",
      border: `1px solid ${
        theme === "dark" ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)"
      }`,
    },
  };

  const sizeStyles = {
    sm: { padding: "0.5rem 0.75rem", fontSize: "0.875rem" },
    md: { padding: "0.75rem 1.5rem", fontSize: "1rem" },
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      title={title}
      aria-label={ariaLabel || title}
      style={{
        ...buttonStyles[variant],
        ...sizeStyles[size],
        borderRadius: "0.75rem",
        fontWeight: "600",
        cursor: disabled ? "not-allowed" : "pointer",
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
        transition: "all 0.3s ease",
        opacity: disabled ? 0.5 : 1,
        ...style,
      }}
    >
      {Icon && <Icon size={size === "sm" ? 16 : 20} />}
      {children}
    </button>
  );
};

export default Mo3tiButton;